import React, { useState, useEffect } from "react";
import { useInvoiceContext, useControlContext } from "../context";
import { Form, Row, Col } from "react-bootstrap";
import {
  faCheck,
  faTimes,
  faBuilding,
} from "@fortawesome/free-solid-svg-icons";
import InputMask from "react-input-mask";
import ButtonNext from "./ButtonNext";
import CardResume from "./CardResume";

function RENFormCustomer(props) {
  const [errors, setErrors] = useState({});
  const [formEnabled, setFormEnabled] = useState(true);
  const [showResumo, setShowResumo] = useState(false);
  const [companyConfirmed, setCompanyConfirmed] = useState(false);
  const [customerName, setCustomerName] = useState("");
  const [isFirstInteraction, setIsFirstInteraction] = useState(true);

  const {
    customer,
    setFieldCustomer,
    cleanCustomer,
    setCustomerCEP,
    setCustomerCity,
    setCustomerState,
    setCustomerNeighborhood,
    setCustomerStreet,
    setCustomerIBGE,
    cnpType,
  } = useInvoiceContext();

  const {
    hiddenFormCustomer,
    showFormCustomer,
    setProgressViewerCustomer,
    enableFormTwo,
    setCanInputCNP,
  } = useControlContext();

  const statesArr = [
    "AC",
    "AL",
    "AP",
    "AM",
    "BA",
    "CE",
    "DF",
    "ES",
    "GO",
    "MA",
    "MT",
    "MS",
    "MG",
    "PA",
    "PB",
    "PR",
    "PE",
    "PI",
    "RJ",
    "RN",
    "RS",
    "RO",
    "RR",
    "SC",
    "SP",
    "SE",
    "TO",
  ];

  const invalidFantasyNameArr = [
    "ASSISTENCIATECNICA",
    "OFICINAMECANICA",
    "OFICINA",
    "CENTROAUTOMOTIVO",
    "INFORMATICA",
    "LOJA",
    "LOJADECELULAR",
    "LOJADECELULARES",
    "OFICINADECELULAR",
    "OFICINADESMARTPHONE",
    "CONSERTOS",
    "ASSISTENCIADECELULAR",
    "ASSISTENCIAEMCELULAR",
    "ASSISTENCIAEMSMARTPHONE",
    "COMERCIO",
    "COMERCIAL",
    "COMERCIALCALCADOS",
    "ASSISTENCIA",
    "MANUTENCAO",
    "MANUTENCOES",
    "AUTOCENTER",
  ];

  const setField = (field, value) => {
    setIsFirstInteraction(false);
    setFieldCustomer(field, value);
    if (!!errors[field])
      setErrors({
        ...errors,
        [field]: null,
      });
  };

  const validateForm = () => {
    const { xfant, xnome, xlgr, xmun, xbairro, nro, cep, uf } = customer;
    const newErrors = {};

    if (!xfant || xfant === "")
      newErrors.xfant = "Nome Fantasia não pode ser vazio!";
    if (!xnome || xnome === "")
      newErrors.xnome = "Razão Social não pode ser vazio!";
    if (!cep || cep === "") newErrors.cep = "CEP não pode ser vazio!";
    if (!xmun || xmun === "") newErrors.xmun = "Município não pode ser vazio!";
    if (!xbairro || xbairro === "")
      newErrors.xbairro = "Bairro não pode ser vazio!";
    if (!nro || nro === "") newErrors.nro = "Número não pode ser vazio!";
    if (!uf || uf === "") newErrors.uf = "UF não pode ser vazio!";
    if (!xlgr || xlgr === "") newErrors.xlgr = "Endereço não pode ser vazio!";
    // if (!form.xpais || form.xpais === '') newErrors.xpais = 'País não pode ser vazio!';
    if (xfant && xfant.length < 3)
      newErrors.xfant = "Nome Fantasia deve ter no mínimo 3 caracteres!";
    if (xnome && xnome.length < 3)
      newErrors.xnome = "Razão Social deve ter no mínimo 3 caracteres!";
    if (xlgr && xlgr.length < 3)
      newErrors.xlgr = "Endereço deve ter no mínimo 3 caracteres!";
    if (xmun && xmun.length < 3)
      newErrors.xmun = "Município deve ter no mínimo 3 caracteres!";
    if (nro && nro.length < 1)
      newErrors.nro = "Número deve ter no mínimo 1 caracter!";
    if (cep && cep.length < 8)
      newErrors.cep = "CEP deve ter no mínimo 8 caracteres!";
    if (uf && uf.length < 2)
      newErrors.uf = "UF deve ter no mínimo 2 caracteres!";
    if (xfant && xfant.length > 80)
      newErrors.xfant = "Nome Fantasia deve ter no máximo 80 caracteres!";
    if (xnome && xnome.length > 120)
      newErrors.xnome = "Razão Social deve ter no máximo 120 caracteres!";
    if (xlgr && xlgr.length > 120)
      newErrors.xlgr = "Endereço deve ter no máximo 120 caracteres!";
    if (xmun && xmun.length > 60)
      newErrors.xmun = "Município deve ter no máximo 60 caracteres!";
    if (nro && nro.length > 60)
      newErrors.nro = "Número deve ter no máximo 60 caracteres!";
    if (cep && cep.length > 12)
      newErrors.cep = "CEP deve ter no máximo 12 caracteres!";
    if (uf && uf.length > 2)
      newErrors.uf = "UF deve ter no máximo 2 caracteres!";
    let sFant = String(
      xfant
        .replace(/\s/g, "") // remove espaços
        .toUpperCase() // transforma em maiúsculo
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^\w\s]/gi, ""), // remove caracteres especiais
    ); // remove acentos

    if (invalidFantasyNameArr.includes(sFant))
      newErrors.xfant = "Nome Fantasia inválido!";

    return newErrors;
  };

  const confirmCustomer = (event) => {
    event.preventDefault();

    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      console.log(formErrors);
      setErrors(formErrors);
    } else {
      setFormEnabled(false);
      showFormCustomer(false);
      setShowResumo(true);
      enableFormTwo();
      setProgressViewerCustomer(true);
      setCompanyConfirmed(true);
    }
  };

  const reset = () => {
    cleanCustomer();
    setErrors({});
    showFormCustomer(false);
    setCanInputCNP(true);
  };

  const handleEdit = () => {
    setFormEnabled(true);
    showFormCustomer(true);
    setShowResumo(false);
    setIsFirstInteraction(false);
  };

  const handleCEP = (event) => {
    console.log("handleCEP");

    setErrors({
      ...errors,
      cep: null,
    });

    let cep = event.target.value.replace(/\D/g, "");

    setCustomerCEP(cep);

    if (cep.length === 8) {
      setCustomerStreet("procurando...");
      setCustomerNeighborhood("procurando...");
      setCustomerCity("procurando...");

      fetch(`https://viacep.com.br/ws/${cep}/json/`)
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          if (data.erro) {
            setErrors({
              ...errors,
              cep: "CEP não encontrado!",
            });
            setCustomerStreet("");
            setCustomerNeighborhood("");
            setCustomerCity("");
          } else {
            setCustomerStreet(data.logradouro);
            setCustomerNeighborhood(data.bairro);
            setCustomerCity(data.localidade);
            setCustomerState(data.uf);
            setCustomerIBGE(data.ibge);
            setErrors({
              ...errors,
              xlgr: null,
              xbairro: null,
              xmun: null,
              uf: null,
            });
            setCustomerCEP(cep);
          }
        });
    }
  };

  useEffect(() => {
    if (cnpType === "CNPJ") {
      setCustomerName("Razão social");
    } else {
      setCustomerName("Nome completo");
    }
  }, [cnpType]);

  useEffect(() => {
    if(isFirstInteraction) {
      const formErrors = validateForm();
      if (Object.keys(formErrors).length === 0) {
        confirmCustomer(new Event('submit'));
      }
    }
  }, [customer]);

  return (
    <>
      <Form hidden={hiddenFormCustomer}>
        <Row>
          <Col xs={12}>
            <label>Nome Fantasia</label>
            <Form.Control
              type="text"
              size="sm"
              placeholder="Nome Fantasia"
              name="fantasia"
              value={customer.xfant}
              onChange={(e) => setField("xfant", e.target.value)}
              isInvalid={!!errors.xfant}
              disabled={!formEnabled}
            />
            <Form.Control.Feedback type="invalid">
              {errors.xfant}
            </Form.Control.Feedback>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <label>{customerName}</label>
            <Form.Control
              type="text"
              size="sm"
              placeholder="Razão Social"
              name="xnome"
              value={customer.xnome}
              onChange={(e) => setField("xnome", e.target.value)}
              isInvalid={!!errors.xnome}
              disabled={!formEnabled}
            />
            <Form.Control.Feedback type="invalid">
              {errors.xnome}
            </Form.Control.Feedback>
          </Col>
        </Row>

        <Row>
          <Col xs={6}>
            <label>CEP</label>
            <Form.Control
              type="text"
              size="sm"
              placeholder="CEP"
              name="cep"
              value={customer.cep}
              onChange={(e) => handleCEP(e)}
              isInvalid={!!errors.cep}
              disabled={!formEnabled}
              as={InputMask}
              mask="99999-999"
              maskChar={""}
            />
            <Form.Control.Feedback type="invalid">
              {errors.cep}
            </Form.Control.Feedback>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <label>Endereço</label>
            <Form.Control
              type="text"
              size="sm"
              placeholder="Endereço"
              name="endereco"
              value={customer.xlgr}
              onChange={(e) => setField("xlgr", e.target.value)}
              isInvalid={!!errors.xlgr}
              disabled={!formEnabled}
            />
            <Form.Control.Feedback type="invalid">
              {errors.xlgr}
            </Form.Control.Feedback>
          </Col>
        </Row>

        <Row>
          <Col xs={9}>
            <label>Bairro</label>
            <Form.Control
              type="text"
              size="sm"
              placeholder="Bairro"
              name="bairro"
              value={customer.xbairro}
              onChange={(e) => setField("xbairro", e.target.value)}
              isInvalid={!!errors.xbairro}
              disabled={!formEnabled}
            />
            <Form.Control.Feedback type="invalid">
              {errors.xbairro}
            </Form.Control.Feedback>
          </Col>
          <Col xs={3}>
            <label>Numero</label>
            <Form.Control
              type="text"
              size="sm"
              placeholder="Numero"
              name="numero"
              value={customer.nro}
              onChange={(e) => setField("nro", e.target.value)}
              isInvalid={!!errors.nro}
              disabled={!formEnabled}
            />
            <Form.Control.Feedback type="invalid">
              {errors.nro}
            </Form.Control.Feedback>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <label>Complemento</label>
            <Form.Control
              type="text"
              size="sm"
              placeholder="Complemento"
              name="complemento"
              value={customer.xcpl}
              onChange={(e) => setField("xcpl", e.target.value)}
              disabled={!formEnabled}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={8}>
            <label>Cidade</label>
            <Form.Control
              type="text"
              size="sm"
              placeholder="Cidade"
              name="cidade"
              value={customer.xmun}
              onChange={(e) => setField("xmun", e.target.value)}
              isInvalid={!!errors.xmun}
              disabled={!formEnabled}
            />
            <Form.Control.Feedback type="invalid">
              {errors.xmun}
            </Form.Control.Feedback>
          </Col>
          <Col xs={4}>
            <label>UF</label>
            <Form.Select
              type="text"
              size="sm"
              placeholder="UF"
              name="uf"
              value={customer.uf}
              onChange={(e) => setField("uf", e.target.value)}
              isInvalid={!!errors.uf}
              disabled={!formEnabled}
            >
              {statesArr.map((state) => (
                <option key={state}>{state}</option>
              ))}
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              {errors.uf}
            </Form.Control.Feedback>
          </Col>
        </Row>

        <Row className="mt-5">
          <Col>
            {!companyConfirmed &&
              <ButtonNext
                variant="outline-danger"
                className="float-start"
                onClick={reset}
                text="Digitar outro CNPJ/CPF"
                faicon={faTimes}
              />
            }
          </Col>
          <Col>
            <ButtonNext
              variant="success"
              className="float-end"
              onClick={confirmCustomer}
              text="Confirmar"
              faicon={faCheck}
            />
          </Col>
        </Row>
      </Form>
      <CardResume
        show={showResumo}
        handleEdit={handleEdit}
        title="Resumo do cliente"
        icon={faBuilding}
      >
        <strong>Nome fantasia:</strong> {customer.xfant} <br />
        <strong>{customerName}:</strong> {customer.xnome} <br />
        <strong>Endereço:</strong> {customer.xlgr}, {customer.nro} -{" "}
        {customer.xbairro} <br />
        <strong>Cidade:</strong> {customer.xmun} - {customer.uf} <br />
        <strong>CEP:</strong> {customer.cep} <br />
      </CardResume>
    </>
  );
}

export default RENFormCustomer;
